import { useAuth } from '@/lib/auth-store';
export function useCurrentUser() {
  const user = useAuth((s) => s.user);
  if (!user) throw new Error('useCurrentUser called without a user');
  return user;
}
